(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-product-details"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.tpProductDetailsInit) return;
    window.tpProductDetailsInit = true;

    var DURATION = 340;
    var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function Accordion(el) {
      this.el = el;
      this.summary = el.querySelector('.tp-pd__head');
      this.body = el.querySelector('.tp-pd__body');
      this.animation = null;
      this.closing = false;
      this.expanding = false;
      if (this.summary && this.body) {
        this.summary.addEventListener('click', this.onClick.bind(this));
      }
    }

    Accordion.prototype.onClick = function (e) {
      if (reduced.matches) return; // mantém o toggle nativo instantâneo
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.closing || !this.el.open) {
        this.open();
      } else if (this.expanding || this.el.open) {
        this.shrink();
      }
    };

    Accordion.prototype.shrink = function () {
      this.closing = true;
      var start = this.el.offsetHeight;
      var end = this.summary.offsetHeight;
      this.run(start, end, false);
    };

    Accordion.prototype.open = function () {
      this.el.style.height = this.el.offsetHeight + 'px';
      this.el.open = true;
      window.requestAnimationFrame(this.expand.bind(this));
    };

    Accordion.prototype.expand = function () {
      this.expanding = true;
      var start = this.el.offsetHeight;
      var end = this.summary.offsetHeight + this.body.offsetHeight;
      this.run(start, end, true);
    };

    Accordion.prototype.run = function (start, end, open) {
      if (this.animation) this.animation.cancel();
      var self = this;
      this.animation = this.el.animate(
        { height: [start + 'px', end + 'px'] },
        { duration: DURATION, easing: EASING }
      );
      this.animation.onfinish = function () { self.finish(open); };
      this.animation.oncancel = function () { self.closing = false; self.expanding = false; };
    };

    Accordion.prototype.finish = function (open) {
      this.el.open = open;
      this.animation = null;
      this.closing = false;
      this.expanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';
    };

    function init(root) {
      var rows = (root || document).querySelectorAll('.tp-pd__row');
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].tpAccordion) rows[i].tpAccordion = new Accordion(rows[i]);
      }
    }

    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tp-size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  function getModal() {
    return document.getElementById('tp-size-guide');
  }

  function getBox(modal) {
    return modal.querySelector('.tp-size-guide__box');
  }

  function updateHint() {
    var modal = getModal();
    if (!modal) return;
    var box = getBox(modal);
    var hint = modal.querySelector('[data-tp-sg-hint]');
    if (!box || !hint) return;
    var remaining = box.scrollHeight - box.scrollTop - box.clientHeight;
    hint.style.opacity = remaining < 32 ? '0' : '1';
  }

  function showColorTable(modal, cor) {
    var btn = modal.querySelector('[data-tp-sg-color="' + cor + '"]');
    var set = btn ? btn.getAttribute('data-tp-sg-set') : 'a';
    modal.querySelectorAll('[data-tp-sg-set-table]').forEach(function (table) {
      table.hidden = table.getAttribute('data-tp-sg-set-table') !== set;
    });
  }

  function setColor(modal, cor) {
    modal.querySelectorAll('[data-tp-sg-color]').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-tp-sg-color') === cor);
    });
    modal.setAttribute('data-tp-sg-cor', cor);
    if (modal.getAttribute('data-tp-sg-mode') === 'sem') {
      showColorTable(modal, cor);
    }
  }

  function setMode(modal, mode) {
    if (!modal) return;
    var cor = modal.getAttribute('data-tp-sg-cor');
    modal.querySelectorAll('[data-tp-sg-bolso]').forEach(function (opt) {
      opt.classList.toggle('is-active', opt.getAttribute('data-tp-sg-bolso') === mode);
    });

    var comPanel = modal.querySelector('[data-tp-sg-panel="com"]');
    var semPanel = modal.querySelector('[data-tp-sg-panel="sem"]');

    if (mode === 'com') {
      var active = modal.querySelector('[data-tp-sg-color="' + cor + '"]');
      if (active && active.hasAttribute('data-tp-sg-only-sem')) {
        var fallback = modal.querySelector('[data-tp-sg-color]:not([data-tp-sg-only-sem])');
        if (fallback) {
          setColor(modal, fallback.getAttribute('data-tp-sg-color'));
        }
      }
      if (comPanel) comPanel.hidden = false;
      if (semPanel) semPanel.hidden = true;
    } else {
      if (comPanel) comPanel.hidden = true;
      if (semPanel) semPanel.hidden = false;
      showColorTable(modal, modal.getAttribute('data-tp-sg-cor'));
    }

    modal.setAttribute('data-tp-sg-mode', mode);
    var box = getBox(modal);
    if (box) box.scrollTop = 0;
    updateHint();
  }

  // Abas da PDP nova (Tabela · Tamanho da peça · Medidas da modelo). Aba que não existe cai na primeira.
  function setAba(modal, aba) {
    var abas = modal.querySelectorAll('[data-tp-sg-aba]');
    if (!abas.length) return;
    if (!modal.querySelector('[data-tp-sg-aba="' + aba + '"]')) aba = abas[0].getAttribute('data-tp-sg-aba');
    abas.forEach(function (btn) {
      var ativa = btn.getAttribute('data-tp-sg-aba') === aba;
      btn.classList.toggle('is-active', ativa);
      btn.setAttribute('aria-selected', ativa ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-tp-sg-aba-painel]').forEach(function (painel) {
      painel.hidden = painel.getAttribute('data-tp-sg-aba-painel') !== aba;
    });
    var box = getBox(modal);
    if (box) box.scrollTop = 0;
    updateHint();
  }

  function openModal(modal) {
    modal = modal || getModal();
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var box = getBox(modal);
    if (box) box.scrollTop = 0;
    updateHint();
  }

  function closeModal() {
    document.querySelectorAll('.tp-size-guide.is-open').forEach(function (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var abre = event.target.closest('[data-tp-size-guide-open]');
    if (abre) {
      event.preventDefault();
      // valor no atributo = outra modal (ex.: "top" abre #tp-size-guide-top, a tabela da peça de acréscimo)
      var alvo = abre.getAttribute('data-tp-size-guide-open');
      openModal(alvo ? document.getElementById('tp-size-guide-' + alvo) : getModal());
      // o atalho "Medidas da modelo" já abre na aba dele; os demais, na Tabela
      if (!alvo && getModal()) setAba(getModal(), abre.getAttribute('data-tp-sg-aba-inicial') || 'tabela');
      return;
    }
    var abaBtn = event.target.closest('[data-tp-sg-aba]');
    if (abaBtn) {
      setAba(getModal(), abaBtn.getAttribute('data-tp-sg-aba'));
      return;
    }
    if (event.target.closest('[data-tp-size-guide-close]')) {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.target.classList && event.target.classList.contains('tp-size-guide')) {
      closeModal();
      return;
    }
    var bolso = event.target.closest('[data-tp-sg-bolso]');
    if (bolso) {
      setMode(getModal(), bolso.getAttribute('data-tp-sg-bolso'));
      return;
    }
    var color = event.target.closest('[data-tp-sg-color]');
    if (color) {
      setColor(getModal(), color.getAttribute('data-tp-sg-color'));
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var modal = getModal();
      if (modal && event.target === getBox(modal)) updateHint();
    },
    true
  );
})();
  } catch(e) { console.error(e); }
})();

})();
